module.exports = __webpack_public_path__ + "static/img/l3.9f4641e9.png";